// components/auto-import-list/component
/* global DEBUG */

import template  from './component.jade'
import style    from './style.scss'
import Store     from 'Store'
import parseTime from 'lib/filters/parseUnixTime'
import parseAutoImportLink from 'lib/filters/parseAutoImportLink'
import onClick   from 'lib/methods/onClick'

var name = 'auto-import-list'
var url = '/api/AutoImportList'

const store = new Store(name)

function compare(a, b) {
    if (a.date < b.date)
        return 1;
    if (a.date > b.date)
        return -1;
    return 0;
}

export default {

  name: name,
  template: template({style: style}),
  props: ['table', 'title'],
  mixins: [parseTime, parseAutoImportLink, onClick],

  data: () => ({
    name: name,
    url: url,
    data: {},
  }),
  events: {
    // при изменении дат, запросим список заявок
    ['dates:' + name]: function (data) {
      this.$set('data', null)
      this.$set('data', data)
      this.$set('data', store.$get(this))
      return false
    },
  },

    computed: {
        table() {

            return this.data.table.sort(compare);
        },
    },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/auto-import-list/component.js
 **/